import { useEffect } from 'react';

export function Fonts({ staticUrl }: { staticUrl: string }) {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      /* Light font (100-300) */
      @font-face {
        font-family: 'lexend';
        font-style: normal;
        font-weight: 100 300;
        font-display: swap;
        src: url('${staticUrl}/fonts/lexend/lexend-light.ttf') format("truetype");
      }

      /* Regular font (400) */
      @font-face {
        font-family: 'lexend';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${staticUrl}/fonts/lexend/lexend-regular.ttf') format("truetype");
      }

      /* Medium font (500) */
      @font-face {
        font-family: 'lexend';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('${staticUrl}/fonts/lexend/lexend-medium.ttf') format("truetype");
      }

      /* Semibold font (600) */
      @font-face {
        font-family: 'lexend';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url('${staticUrl}/fonts/lexend/lexend-semibold.ttf') format("truetype");
      }

      /* Bold font (700-900) */
      @font-face {
        font-family: 'lexend';
        font-style: normal;
        font-weight: 700 900;
        font-display: swap;
        src: url('${staticUrl}/fonts/lexend/lexend-bold.ttf') format("truetype");
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, [staticUrl]);

  return null;
}
